import { 
  Box, 
  Container, 
  Typography, 
  Grid, 
  Card, 
  CardContent,
  Button,
  Paper,
  Stack,
  Chip,
  Avatar,
  IconButton,
  Tab,
  Tabs,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Widgets as WidgetIcon,
  Web as WebIcon,
  PlayArrow as PlayIcon,
  Code as CodeIcon,
  PhoneAndroid as MobileIcon,
  DesktopMac as DesktopIcon,
  Tablet as TabletIcon,
  CheckCircle as CheckIcon,
  Article as ArticleIcon,
  Category as CategoryIcon,
  Person as PersonIcon,
  Search as SearchIcon,
  Edit as EditIcon,
  Settings as SettingsIcon,
  People as PeopleIcon,
  Palette as PaletteIcon,
  Launch as LaunchIcon,
  VideoLibrary as VideoIcon,
  Book,
  MenuBook,
} from '@mui/icons-material';
import { useState } from 'react';

const DemoPage = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [hoveredCard, setHoveredCard] = useState(null);

  // Demo Kategorileri
  const demoCategories = [
    {
      icon: <DashboardIcon sx={{ fontSize: 60 }} />,
      title: "Admin Panel Demo",
      subtitle: "Güçlü Yönetim Paneli",
      description: "Haber yönetiminden sayfa tasarımına, kullanıcı yönetiminden tema ayarlarına kadar tüm admin paneli özelliklerini canlı olarak deneyin",
      color: "#1e40af",
      gradient: "linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)",
      features: [
        {
          icon: <DashboardIcon />,
          title: "Dashboard ve İstatistikler",
          description: "Gerçek zamanlı istatistikler, grafikler ve raporlar"
        },
        {
          icon: <EditIcon />,
          title: "Haber Ekleme/Düzenleme",
          description: "WYSIWYG editör ile kolay haber yönetimi"
        },
        {
          icon: <PaletteIcon />,
          title: "Sayfa Tasarımcısı",
          description: "Sürükle-bırak ile sayfa tasarlama"
        },
        {
          icon: <WidgetIcon />,
          title: "Widget Yönetimi",
          description: "70+ widget'ı kolayca yönetin"
        },
        {
          icon: <PeopleIcon />,
          title: "Kullanıcı Yönetimi",
          description: "Rol tabanlı yetkilendirme sistemi"
        },
        {
          icon: <SettingsIcon />,
          title: "Tema Ayarları",
          description: "Renk, font ve layout özelleştirme"
        }
      ],
      demoUrl: "https://demo-admin.example.com",
      credentials: {
        username: "demo@example.com",
        password: "demo123"
      }
    },
    {
      icon: <WebIcon sx={{ fontSize: 60 }} />,
      title: "Frontend Demo",
      subtitle: "Canlı Haber Sitesi Örnekleri",
      description: "5+ farklı tasarım seçeneği ile anasayfa, haber detay, kategori ve yazar sayfalarını görün. Mobil, tablet ve desktop görünümleri test edin",
      color: "#dc2626",
      gradient: "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)",
      features: [
        {
          icon: <WebIcon />,
          title: "Anasayfa Örnekleri",
          description: "5+ farklı anasayfa tasarımı"
        },
        {
          icon: <ArticleIcon />,
          title: "Haber Detay Sayfaları",
          description: "Farklı haber detay layoutları"
        },
        {
          icon: <CategoryIcon />,
          title: "Kategori Sayfaları",
          description: "Kategori bazlı haber listeleme"
        },
        {
          icon: <PersonIcon />,
          title: "Yazar Sayfaları",
          description: "Yazar profilleri ve yazıları"
        },
        {
          icon: <SearchIcon />,
          title: "Arama Sonuçları",
          description: "Gelişmiş arama ve filtreleme"
        },
        {
          icon: <MobileIcon />,
          title: "Mobil Görünüm",
          description: "Responsive tasarım örnekleri"
        }
      ],
      demoUrl: "https://demo-frontend.example.com",
      credentials: null
    },
    {
      icon: <WidgetIcon sx={{ fontSize: 60 }} />,
      title: "Widget Galerisi",
      subtitle: "70+ Widget Canlı Önizleme",
      description: "Tüm widget'ları canlı olarak görün, özelleştirin ve kodlarını inceleyin. Her widget için kullanım senaryoları ve örnekler",
      color: "#059669",
      gradient: "linear-gradient(135deg, #059669 0%, #10b981 100%)",
      features: [
        {
          icon: <WidgetIcon />,
          title: "70+ Widget Önizleme",
          description: "Tüm widget'ların canlı gösterimi"
        },
        {
          icon: <PaletteIcon />,
          title: "Özelleştirme Örnekleri",
          description: "Renk, boyut ve stil seçenekleri"
        },
        {
          icon: <MobileIcon />,
          title: "Responsive Görünümler",
          description: "Mobil, tablet ve desktop uyumluluğu"
        },
        {
          icon: <CodeIcon />,
          title: "Kod Örnekleri",
          description: "Her widget için kod snippet'leri"
        },
        {
          icon: <Book />,
          title: "Kullanım Senaryoları",
          description: "Gerçek dünya kullanım örnekleri"
        },
        {
          icon: <VideoIcon />,
          title: "Video Rehberler",
          description: "Widget kullanım video eğitimleri"
        }
      ],
      demoUrl: "https://demo-widgets.example.com",
      credentials: null
    }
  ];

  // Widget Kategorileri
  const widgetShowcase = [
    {
      category: "Manşet Widget'ları",
      count: "10+",
      icon: <ArticleIcon />,
      color: "#1e40af",
      examples: [
        "Slider Manşet (6 varyasyon)",
        "Video Manşet",
        "Tam Ekran Hero",
        "Otomatik Geçişli Manşet"
      ]
    },
    {
      category: "Haber Listeleme",
      count: "30+",
      icon: <WidgetIcon />,
      color: "#dc2626",
      examples: [
        "Grid Layout (2x1, 3x1, 3x2, 3x4, 4x4)",
        "Liste Görünümleri",
        "Kart Tasarımları",
        "Masonry Layout"
      ]
    },
    {
      category: "Finans Widget'ları",
      count: "8+",
      icon: <DashboardIcon />,
      color: "#059669",
      examples: [
        "Döviz Kurları (3 varyasyon)",
        "Altın Fiyatları",
        "Kripto Para",
        "Borsa Widget'ları"
      ]
    },
    {
      category: "Hava Durumu",
      count: "4+",
      icon: <WebIcon />,
      color: "#0ea5e9",
      examples: [
        "4 Farklı Tasarım",
        "Şehir Bazlı",
        "5 Günlük Tahmin",
        "Detaylı Meteoroloji"
      ]
    },
    {
      category: "Spor Widget'ları",
      count: "4+",
      icon: <DashboardIcon />,
      color: "#ea580c",
      examples: [
        "Lig Tablosu",
        "Maç Sonuçları",
        "Spor Ticker",
        "Canlı Skor"
      ]
    },
    {
      category: "Genel Widget'lar",
      count: "20+",
      icon: <WidgetIcon />,
      color: "#7c3aed",
      examples: [
        "Newsletter Widget",
        "Trend Haberler",
        "Popüler Haberler",
        "Sosyal Medya Feed"
      ]
    }
  ];

  // Dokümantasyon ve Kaynaklar
  const resources = [
    {
      icon: <Book/>,
      title: "Başlangıç Rehberi",
      description: "15 dakikada kurulum ve ilk haber yayını",
      color: "#1e40af",
      items: [
        "Hızlı kurulum",
        "İlk yapılandırma",
        "Kullanıcı oluşturma",
        "İlk haber yayınlama"
      ]
    },
    {
      icon: <MenuBook />,
      title: "Kullanıcı Kılavuzu",
      description: "Detaylı kullanım kılavuzu ve best practices",
      color: "#dc2626",
      items: [
        "Haber yönetimi detayları",
        "Sayfa tasarım rehberi",
        "Widget kullanım kılavuzu",
        "SEO optimizasyonu"
      ]
    },
    {
      icon: <CodeIcon />,
      title: "Geliştirici Dokümantasyonu",
      description: "API referansı ve entegrasyon örnekleri",
      color: "#059669",
      items: [
        "GraphQL API referansı",
        "Authentication akışı",
        "Özel widget geliştirme",
        "Entegrasyon örnekleri"
      ]
    },
    {
      icon: <VideoIcon />,
      title: "Video Eğitimler",
      description: "Adım adım video rehberler ve ipuçları",
      color: "#7c3aed",
      items: [
        "Platform tanıtımı",
        "Adım adım kullanım",
        "İpuçları ve püf noktaları",
        "Sık sorulan sorular"
      ]
    }
  ];

  // Cihaz Önizleme
  const devicePreviews = [
    { icon: <DesktopIcon />, name: "Desktop", width: "1920x1080" },
    { icon: <TabletIcon />, name: "Tablet", width: "768x1024" },
    { icon: <MobileIcon />, name: "Mobile", width: "375x667" }
  ];

  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          py: { xs: 10, md: 16 },
          background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
          color: 'white',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `
              radial-gradient(circle at 20% 30%, rgba(59, 130, 246, 0.2) 0%, transparent 50%),
              radial-gradient(circle at 80% 70%, rgba(139, 92, 246, 0.2) 0%, transparent 50%)
            `,
            pointerEvents: 'none'
          }
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ textAlign: 'center', mb: 10 }}>
            <Typography
              variant="overline"
              sx={{
                fontSize: '0.9rem',
                fontWeight: 900,
                letterSpacing: '0.1em',
                color: '#60a5fa',
                mb: 2,
                display: 'block',
                textTransform: 'uppercase'
              }}
            >
              CANLI DEMO
            </Typography>

            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '2.5rem', md: '4.5rem' },
                fontWeight: 800,
                mb: 4,
                color: 'white',
                fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                lineHeight: 1.1
              }}
            >
              Kendiniz Deneyin, Karar Verin
            </Typography>

            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: '1.2rem', md: '1.5rem' },
                color: 'rgba(255,255,255,0.9)',
                maxWidth: 800,
                mx: 'auto',
                lineHeight: 1.6,
                fontWeight: 400,
                mb: 6
              }}
            >
              Admin paneli, frontend tasarımları ve 70+ widget'ı canlı olarak test edin. 
              Hiçbir kurulum gerektirmez, hemen başlayın
            </Typography>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} justifyContent="center">
              <Button
                variant="contained"
                size="large"
                startIcon={<PlayIcon />}
                sx={{
                  background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
                  color: 'white',
                  px: 6,
                  py: 2.5,
                  fontSize: '1.1rem',
                  fontWeight: 700,
                  borderRadius: 2,
                  textTransform: 'none',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 10px 30px rgba(59, 130, 246, 0.3)'
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                Admin Paneli Deneyin
              </Button>
              <Button
                variant="outlined"
                size="large"
                startIcon={<LaunchIcon />}
                sx={{
                  borderColor: 'white',
                  color: 'white',
                  px: 6,
                  py: 2.5,
                  fontSize: '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  borderWidth: 2,
                  textTransform: 'none',
                  '&:hover': {
                    borderWidth: 2,
                    background: 'rgba(255, 255, 255, 0.1)',
                    transform: 'translateY(-2px)'
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                Frontend Demo
              </Button>
            </Stack>
          </Box>
        </Container>
      </Box>

      {/* Demo Kategorileri */}
      <Box sx={{ py: { xs: 10, md: 16 }, background: 'white' }}>
        <Container maxWidth="xl">
          <Grid container spacing={6}>
            {demoCategories.map((demo, index) => (
              <Grid item xs={12} key={index}>
                <Paper
                  elevation={0}
                  onMouseEnter={() => setHoveredCard(index)}
                  onMouseLeave={() => setHoveredCard(null)}
                  sx={{
                    p: { xs: 4, md: 6 },
                    background: '#ffffff',
                    border: '2px solid #e2e8f0',
                    borderRadius: 4,
                    position: 'relative',
                    cursor: 'pointer',
                    transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                    overflow: 'hidden',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      height: 6,
                      background: demo.gradient,
                      transform: hoveredCard === index ? 'scaleX(1)' : 'scaleX(0)',
                      transformOrigin: 'left',
                      transition: 'transform 0.4s ease'
                    },
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: `0 30px 60px ${demo.color}20, 0 15px 30px rgba(0, 0, 0, 0.1)`,
                      borderColor: demo.color
                    }
                  }}
                >
                  <Grid container spacing={4} alignItems="center">
                    {/* Sol Taraf - İçerik */}
                    <Grid item xs={12} md={7}>
                      {/* Icon & Title */}
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 100,
                            height: 100,
                            borderRadius: 3,
                            background: `${demo.color}15`,
                            color: demo.color,
                            mr: 3,
                            transition: 'all 0.4s ease',
                            transform: hoveredCard === index ? 'scale(1.1) rotate(5deg)' : 'scale(1)'
                          }}
                        >
                          {demo.icon}
                        </Box>
                        <Box>
                          <Typography
                            variant="h3"
                            sx={{
                              fontWeight: 800,
                              mb: 1,
                              color: '#1e293b',
                              fontSize: { xs: '1.8rem', md: '2.5rem' },
                              fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif'
                            }}
                          >
                            {demo.title}
                          </Typography>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              background: demo.gradient,
                              backgroundClip: 'text',
                              WebkitBackgroundClip: 'text',
                              WebkitTextFillColor: 'transparent',
                              fontSize: '1.2rem'
                            }}
                          >
                            {demo.subtitle}
                          </Typography>
                        </Box>
                      </Box>

                      {/* Description */}
                      <Typography
                        variant="body1"
                        sx={{
                          color: '#64748b',
                          lineHeight: 1.8,
                          mb: 4,
                          fontSize: '1.1rem'
                        }}
                      >
                        {demo.description}
                      </Typography>

                      {/* Features Grid */}
                      <Grid container spacing={2} sx={{ mb: 4 }}>
                        {demo.features.map((feature, idx) => (
                          <Grid item xs={12} sm={6} key={idx}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: 40,
                                  height: 40,
                                  borderRadius: 2,
                                  background: `${demo.color}15`,
                                  color: demo.color,
                                  mr: 2,
                                  flexShrink: 0
                                }}
                              >
                                {feature.icon}
                              </Box>
                              <Box>
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    fontWeight: 700,
                                    color: '#1e293b',
                                    mb: 0.5
                                  }}
                                >
                                  {feature.title}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  sx={{
                                    color: '#64748b',
                                    fontSize: '0.85rem'
                                  }}
                                >
                                  {feature.description}
                                </Typography>
                              </Box>
                            </Box>
                          </Grid>
                        ))}
                      </Grid>

                      {/* CTA Button */}
                      <Button
                        variant="contained"
                        size="large"
                        startIcon={<LaunchIcon />}
                        sx={{
                          background: demo.gradient,
                          color: 'white',
                          px: 4,
                          py: 1.5,
                          fontSize: '1rem',
                          fontWeight: 600,
                          borderRadius: 2,
                          textTransform: 'none',
                          '&:hover': {
                            transform: 'translateY(-2px)',
                            boxShadow: `0 10px 30px ${demo.color}40`
                          },
                          transition: 'all 0.3s ease'
                        }}
                      >
                        Canlı Demo'yu Aç
                      </Button>
                    </Grid>

                    {/* Sağ Taraf - Credentials veya Info */}
                    <Grid item xs={12} md={5}>
                      <Box
                        sx={{
                          background: `linear-gradient(135deg, ${demo.color}08, ${demo.color}15)`,
                          borderRadius: 3,
                          p: 4,
                          border: `1px solid ${demo.color}30`
                        }}
                      >
                        {demo.credentials ? (
                          <>
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 700,
                                mb: 3,
                                color: '#1e293b',
                                textAlign: 'center'
                              }}
                            >
                              Demo Giriş Bilgileri
                            </Typography>
                            <Box
                              sx={{
                                background: 'white',
                                borderRadius: 2,
                                p: 3,
                                mb: 2,
                                border: '1px solid #e2e8f0'
                              }}
                            >
                              <Typography
                                variant="caption"
                                sx={{
                                  color: '#64748b',
                                  fontWeight: 600,
                                  textTransform: 'uppercase',
                                  fontSize: '0.75rem',
                                  mb: 1,
                                  display: 'block'
                                }}
                              >
                                Kullanıcı Adı
                              </Typography>
                              <Typography
                                variant="body1"
                                sx={{
                                  color: '#1e293b',
                                  fontWeight: 600,
                                  fontFamily: 'monospace',
                                  fontSize: '1rem'
                                }}
                              >
                                {demo.credentials.username}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                background: 'white',
                                borderRadius: 2,
                                p: 3,
                                border: '1px solid #e2e8f0'
                              }}
                            >
                              <Typography
                                variant="caption"
                                sx={{
                                  color: '#64748b',
                                  fontWeight: 600,
                                  textTransform: 'uppercase',
                                  fontSize: '0.75rem',
                                  mb: 1,
                                  display: 'block'
                                }}
                              >
                                Şifre
                              </Typography>
                              <Typography
                                variant="body1"
                                sx={{
                                  color: '#1e293b',
                                  fontWeight: 600,
                                  fontFamily: 'monospace',
                                  fontSize: '1rem'
                                }}
                              >
                                {demo.credentials.password}
                              </Typography>
                            </Box>
                            <Typography
                              variant="caption"
                              sx={{
                                color: '#64748b',
                                display: 'block',
                                textAlign: 'center',
                                mt: 3
                              }}
                            >
                              Demo hesabı her 24 saatte bir sıfırlanır
                            </Typography>
                          </>
                        ) : (
                          <>
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 700,
                                mb: 3,
                                color: '#1e293b',
                                textAlign: 'center'
                              }}
                            >
                              Hemen Deneyin
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                color: '#64748b',
                                textAlign: 'center',
                                lineHeight: 1.7,
                                mb: 3
                              }}
                            >
                              Hiçbir kayıt veya giriş gerektirmez. Tüm özellikleri özgürce keşfedin
                            </Typography>
                            <Stack spacing={2}>
                              {devicePreviews.map((device, idx) => (
                                <Box
                                  key={idx}
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    background: 'white',
                                    borderRadius: 2,
                                    p: 2,
                                    border: '1px solid #e2e8f0'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box
                                      sx={{
                                        color: demo.color,
                                        mr: 2
                                      }}
                                    >
                                      {device.icon}
                                    </Box>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        fontWeight: 600,
                                        color: '#1e293b'
                                      }}
                                    >
                                      {device.name}
                                    </Typography>
                                  </Box>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: '#64748b',
                                      fontFamily: 'monospace'
                                    }}
                                  >
                                    {device.width}
                                  </Typography>
                                </Box>
                              ))}
                            </Stack>
                          </>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Widget Showcase */}
      <Box 
        sx={{ 
          py: { xs: 10, md: 16 },
          background: `
            linear-gradient(
              135deg,
              #ffffff 0%,
              #f8fafc 25%,
              #f1f5f9 50%,
              #e2e8f0 75%,
              #cbd5e1 100%
            )
          `
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ textAlign: 'center', mb: 10 }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                mb: 3,
                background: 'linear-gradient(135deg, #1e293b 0%, #1e40af 50%, #dc2626 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}
            >
              70+ Widget Galerisi
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: '#64748b',
                maxWidth: 700,
                mx: 'auto',
                lineHeight: 1.6
              }}
            >
              Tüm widget'ları canlı olarak görün, özelleştirin ve kodlarını inceleyin
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {widgetShowcase.map((category, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  elevation={0}
                  sx={{
                    p: 4,
                    height: '100%',
                    background: 'white',
                    border: '1px solid #e2e8f0',
                    borderRadius: 3,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      boxShadow: `0 10px 30px ${category.color}20`,
                      borderColor: category.color
                    }
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 50,
                        height: 50,
                        borderRadius: 2,
                        background: `${category.color}15`,
                        color: category.color,
                        mr: 2
                      }}
                    >
                      {category.icon}
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="h6" sx={{ fontWeight: 700, color: '#1e293b' }}>
                        {category.category}
                      </Typography>
                    </Box>
                    <Chip 
                      label={category.count}
                      size="small"
                      sx={{
                        background: category.color,
                        color: 'white',
                        fontWeight: 600
                      }}
                    />
                  </Box>
                  <List dense>
                    {category.examples.map((example, idx) => (
                      <ListItem key={idx} sx={{ px: 0, py: 0.5 }}>
                        <ListItemIcon sx={{ minWidth: 28 }}>
                          <CheckIcon sx={{ color: category.color, fontSize: 18 }} />
                        </ListItemIcon>
                        <ListItemText 
                          primary={example}
                          primaryTypographyProps={{
                            fontSize: '0.9rem',
                            color: '#64748b'
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Card>
              </Grid>
            ))}
          </Grid>

          <Box sx={{ textAlign: 'center', mt: 8 }}>
            <Button
              variant="contained"
              size="large"
              startIcon={<WidgetIcon />}
              sx={{
                background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
                color: 'white',
                px: 6,
                py: 2,
                fontSize: '1.1rem',
                fontWeight: 600,
                borderRadius: 2,
                textTransform: 'none',
                '&:hover': {
                  background: 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 10px 30px rgba(30, 64, 175, 0.3)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              Tüm Widget'ları Görüntüle
            </Button>
          </Box>
        </Container>
      </Box>

      {/* Dokümantasyon ve Kaynaklar */}
      <Box sx={{ py: { xs: 10, md: 16 }, background: 'white' }}>
        <Container maxWidth="xl">
          <Box sx={{ textAlign: 'center', mb: 10 }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                mb: 3,
                color: '#1e293b'
              }}
            >
              Dokümantasyon ve Kaynaklar
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: '#64748b',
                maxWidth: 700,
                mx: 'auto',
                lineHeight: 1.6
              }}
            >
              Başlangıç rehberlerinden geliştirici dokümantasyonuna kadar her şey
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {resources.map((resource, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card
                  elevation={0}
                  sx={{
                    p: 4,
                    height: '100%',
                    background: 'white',
                    border: '2px solid #e2e8f0',
                    borderRadius: 3,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      boxShadow: `0 10px 30px ${resource.color}20`,
                      borderColor: resource.color
                    }
                  }}
                >
                  <Box
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 60,
                      height: 60,
                      borderRadius: 2,
                      background: `${resource.color}15`,
                      color: resource.color,
                      mb: 3,
                      '& svg': {
                        fontSize: '2rem'
                      }
                    }}
                  >
                    {resource.icon}
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      mb: 2,
                      color: '#1e293b'
                    }}
                  >
                    {resource.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#64748b',
                      lineHeight: 1.7,
                      mb: 3
                    }}
                  >
                    {resource.description}
                  </Typography>
                  <List dense>
                    {resource.items.map((item, idx) => (
                      <ListItem key={idx} sx={{ px: 0, py: 0.5 }}>
                        <ListItemIcon sx={{ minWidth: 28 }}>
                          <CheckIcon sx={{ color: resource.color, fontSize: 16 }} />
                        </ListItemIcon>
                        <ListItemText 
                          primary={item}
                          primaryTypographyProps={{
                            fontSize: '0.85rem',
                            color: '#64748b'
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* CTA Section */}
      <Box
        sx={{
          py: { xs: 10, md: 16 },
          background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
          color: 'white',
          textAlign: 'center'
        }}
      >
        <Container maxWidth="md">
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2.5rem', md: '3.5rem' },
              fontWeight: 800,
              mb: 3
            }}
          >
            Hazır mısınız?
          </Typography>
          <Typography
            variant="h6"
            sx={{
              mb: 6,
              opacity: 0.95,
              lineHeight: 1.6,
              maxWidth: 600,
              mx: 'auto'
            }}
          >
            Demo'yu beğendiniz mi? Hemen başlayın ve kendi haber sitenizi oluşturun. 
            30 gün ücretsiz deneme, kredi kartı gerekmez
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} justifyContent="center">
            <Button
              variant="contained"
              size="large"
              sx={{
                background: 'white',
                color: '#1e40af',
                px: 6,
                py: 2.5,
                fontSize: '1.1rem',
                fontWeight: 700,
                borderRadius: 2,
                textTransform: 'none',
                '&:hover': {
                  background: '#f8fafc',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              Ücretsiz Başlayın
            </Button>
            <Button
              variant="outlined"
              size="large"
              sx={{
                borderColor: 'white',
                color: 'white',
                px: 6,
                py: 2.5,
                fontSize: '1.1rem',
                fontWeight: 600,
                borderRadius: 2,
                borderWidth: 2,
                textTransform: 'none',
                '&:hover': {
                  borderWidth: 2,
                  background: 'rgba(255, 255, 255, 0.1)',
                  transform: 'translateY(-2px)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              Satış Ekibiyle Görüşün
            </Button>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
};

export default DemoPage;

